import nipplejs from "nipplejs"


// ------------------------------------------------------------


export class Joystick {

    constructor(params) {
        // this.#_params = params
    }

    init() {
        const avatar = window.avatar 
        
        const joystick = nipplejs.create({
            zone: document.querySelector('.joystick-container'),
            size: 120,
        })
        
        joystick.on('added', (e, nipple) => {
            avatar._movementStart()
            
            nipple.on('move', (e, data) => {
                avatar._movementData(data)
            })
        }).on('removed', (e, nipple) => {
            nipple.off('move')
            avatar._movementFinished()
        })
    }

}